import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FaDice } from 'react-icons/fa6';
import { SITE } from '../data/site';
import './header.css';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/welcome-bonuses', label: 'Welcome Bonuses' },
  { to: '/new-casino-sites', label: 'New Casinos' },
  { to: '/how-it-works', label: 'How It Works' },
  { to: '/responsible-gambling', label: 'Safe Gambling' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`site-header${scrolled ? ' site-header--scrolled' : ''}`}>
      <div className="container site-header__inner">
        <Link to="/" className="site-header__logo" aria-label={`${SITE.name} home`}>
          <span className="site-header__logo-icon" aria-hidden="true">
            <FaDice size={22} />
          </span>
          <span className="site-header__logo-text">{SITE.name}</span>
        </Link>

        <nav className={`site-header__nav${menuOpen ? ' site-header__nav--open' : ''}`} aria-label="Main navigation">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              className={({ isActive }) =>
                'site-header__nav-link' + (isActive ? ' site-header__nav-link--active' : '')
              }
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="site-header__actions">
          <span className="site-header__age-badge">18+</span>
          <button
            className="site-header__menu-btn"
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
    </header>
  );
}
